import { FC, InputHTMLAttributes } from "react";
import { FormControlProps } from "react-bootstrap/FormControl";
import { FormControlSelectChoice } from "app/component/form/control/FormControlSelectChoice";
import { ReportVersionStatus } from "app/api/graph/types";
import { reportVersionStatusLabel } from "app/api/graph/strings";

type Props = Omit<InputHTMLAttributes<HTMLSelectElement> & FormControlProps, "type" | "value" | "onChange"> & {
    value: ReportVersionStatus | undefined;
    onChange: (value: ReportVersionStatus) => void;
};

const options = [
    ReportVersionStatus.Scoping,
    ReportVersionStatus.Prerequisites,
    ReportVersionStatus.Booked,
    ReportVersionStatus.Testing,
    ReportVersionStatus.Reporting,
    ReportVersionStatus.QualityAssurance,
    ReportVersionStatus.Published,
].map((value) => ({
    label: reportVersionStatusLabel(value),
    value,
}));

export const FormControlSelectReportVersionStatus: FC<Props> = ({ value, onChange, ...props }) => (
    <FormControlSelectChoice {...props} options={options} value={value} onChange={onChange} />
);
